import { Container } from "reactstrap";
import FormSection from "./FormSection";
import DeleteFileSection from "./DeleteFileSection";
import UploadSection from "./UploadSection";
import { useContext } from "react";
import { BillingUploadContext } from "./BillingUploadContext";

const BillingUploadSteps = () => {
  const billingUploadCtx = useContext(BillingUploadContext);

  return (
    <Container>
      <FormSection />
    
      {billingUploadCtx.stepStatus === "pending" && (
        <DeleteFileSection />
      )}
    
      {billingUploadCtx.stepStatus === "approved" && (
        <UploadSection />
      )}
    </Container>
  )
}

export default BillingUploadSteps;